import React from "react";
import { Box, Paper, Typography, Avatar } from "@mui/material";

const ScrollBarPage = ({ answerContent, questionItemContent }) => {
  
  const colors = {
    primary: "#17082d",
    studentBubble: "#f0f2f5", // Gray for Student Question
  };

  return (
    <Box
      sx={{
        p: 3,
        display: "flex",
        flexDirection: "column",
        gap: 3,
        minHeight: "100%", // Ensures background covers area
        bgcolor: "#f5f7fb",
        backgroundImage: "radial-gradient(#e0e0e0 1px, transparent 1px)",
        backgroundSize: "20px 20px",
      }}
    >
      {/* 1. STUDENT QUESTION (Left) */}
      <Box sx={{ display: "flex", justifyContent: "flex-start", gap: 2 }}>
         <Avatar sx={{ bgcolor: "#9e9e9e", width: 32, height: 32 }}>S</Avatar>
         <Box sx={{ maxWidth: "80%" }}>
            <Paper
                elevation={0}
                sx={{
                    p: 2,
                    borderRadius: "0px 15px 15px 15px",
                    bgcolor: colors.studentBubble,
                    color: "#000",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.05)"
                }}
            >
                <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 0.5, fontSize: "0.75rem" }}>
                    Student Question
                </Typography>
                <Typography variant="body1" sx={{whiteSpace: 'pre-wrap'}}>
                    {questionItemContent}
                </Typography>
            </Paper>
         </Box>
      </Box>

      {/* 2. INSTRUCTOR ANSWER (Right) */}
      {answerContent && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Box sx={{ maxWidth: "80%" }}>
                <Paper
                    elevation={0}
                    sx={{
                        p: 2,
                        borderRadius: "15px 0px 15px 15px",
                        bgcolor: colors.primary,
                        color: "#fff",
                        boxShadow: "0 2px 8px rgba(229, 57, 53, 0.4)"
                    }}
                >
                    <Typography variant="subtitle2" sx={{ mb: 0.5, fontSize: "0.75rem", color: "#ffcdd2", textAlign: "right" }}>
                        Your Answer
                    </Typography>
                    <Typography variant="body1" sx={{whiteSpace: 'pre-wrap'}}>
                        {answerContent}
                    </Typography>
                </Paper>
            </Box>
            <Avatar sx={{ bgcolor: colors.dark, width: 32, height: 32 }}>You</Avatar>
        </Box>
      )}
    </Box>
  );
};

export default ScrollBarPage;

